import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user.js'
import datas from './modules/datas.js'
import tagsView from './modules/tagsView.js'

Vue.use(Vuex)
let printComplate2 = {
  print_width: 190, // 打印宽度 mm
  date_type: 'yyyy-MM-dd',
  title_style: {
    FS: 8, // px
    LH: 10, // px
    FW: false, // 是否加粗 bold
  }, // 标题样式
  topList: [{
    s: 1,
    l: '',
    v: ''
  }],
  qrcode: {
    show: false,
    type: 1
  },
  btmList: [{
    s: 1,
    l: '',
    v: '',
    w: 47
  }],
  top_style: {
    FS: 4, // px
    LH: 5, // px
    col: 2
  },
  theads: [{
    s: 1,
    l: '',
    v: '',
    w: 28,
    d: false
  }],
  table_style: {
    FS: 4, // px
    LH: 5, // px
    row: 0,
    FF: '' //字体
  },
  top_rules: [1], // 1重复打印页头 2隐藏客户电话
  btm_rules: [], // 1显示附表  主要用于固定行分页打印
  thead_rules: [1, 2, 3, 4, 5], // max 8
  total_rules: [1, 2, 3, 4, 5, 6], // max 18
  additional_rules: [], //1显示附表  主要用于固定行分页打印
  additional: [{
    s: 1,
    v: '',
    w: 30
  }],
  tips: {
    show: true,
    text: '①存根白 ②客户红 ③回单黄'
  },
  show_page: false, //是否显示页码
}

const store = new Vuex.Store({
  state: {
    version: '3.2.8',
    requestTimes: {}, //记录url请求的时间戳 后续用于限制接口频繁调用
    //存放的键值对就是所要管理的状态
    companyName: '',
    downLoadingNum: 0,
    order_print_set: [], //订单打印自定义设置
    complateNameTip: '模板', // 模板两个字的翻译
    complate_order_main: {
      uuid: '', // 用于客户编辑时 为客户定制模板 已定制模板的客户不在弹出模板弹窗
      type: '0', // 模板类型 0配置模板 1标准模板 2自定义模板
      tab_name: '', //模板名称
      table_name: '《业务订单》',
    },
    complate_order0: {
      company_name: "",
      item: [0, 1, 2, 3, 4, 5], //默认显示 itemList value
      item_sort: [1, 2, 3, 4, 5, 6], //默认排序 itemList sort
      goods_num: "1",
      delivery_num: '0',
      unit: "1",
      code: '0',
      cate: "0",
      sign_str: '',
      order_time: '',
      order_sum: '1',
      contact: '0',
      custom: ''
    },
    complate_order1: {
      // 1标准模板
      tax_rate: '0', // 标准模板-是否打印税率税费  type=1标准模板时有效
      is_stockout: '1', // 标准模板-缺货商品是否打印 1打印 0不打印
      company_logo: '', // 标准模板-自定义公司logo
      company_name: '', // 标准模板-自定义公司名称
      company_address: '', // 标准模板-自定义公司地址
      company_phone: '', // 标准模板-自定义公司电话
      company_code: '', // 标准模板-自定义公司注册号
      label_code: '', // 标准模板-自定义-发票号文案
      label_date: '', // 标准模板-自定义-日期文案
      table_row: 20, // 标准模板-自定义-每页最多行数
    }, // 和送货单一样
    complate_order2: {
      ...printComplate2,
      thead_rules: [1, 2, 3, 4],
    }, // 2自定义模板 订单
    warehouse_receipt_print_set: {
      company_name: '',
      line_num: '',
      theads: [{
        l: '序',
        v: 'index',
        s: 1,
        c: true
      }, {
        l: '品种名称',
        v: 'title',
        s: 2,
        c: true
      }, {
        l: '规格',
        v: 'spec_name',
        s: 3,
        c: true
      }, {
        l: '单位',
        v: 'unit',
        s: 4,
        c: true
      }, {
        l: '份数',
        v: 'num',
        s: 5,
        c: true
      }, {
        l: '数量',
        v: 'in_num',
        s: 6,
        c: true
      }, {
        l: '单价',
        v: 'price',
        s: 7,
        c: true
      }, {
        l: '金额',
        v: 'in_money',
        s: 8,
        c: true
      }, {
        l: '时间',
        v: 'time',
        s: 9,
        c: true
      }, {
        l: '备注',
        v: 'remark',
        s: 10,
        c: true
      }]
    }, //入库单打印模板

    delivery_print_set: [], //送货打印自定义设置
    complate_delivery_main: {
      uuid: '', // 用于客户编辑时 为客户定制模板 已定制模板的客户不在弹出模板弹窗
      type: '0', // 模板类型 0配置模板 1标准模板 2自定义模板
      tab_name: '', //模板名称
      table_name: '《送货单》',
    }, // 更改模板参数时 请注意 complate_delivery0 complate_delivery1 complate_delivery2相同参数必须是同一数据类型且值相同
    complate_delivery0: {
      // 0配置模板
      company_name: '',
      item: [0, 1, 2, 3, 4, 5, 6, 7], //默认显示 itemList value
      item_sort: [1, 2, 3, 4, 5, 6, 7, 8, 2, 3, 3], //默认排序 itemList sort
      goods_num: '1', //商品份数 1打印 0不打印
      code: '1', //二维码 1打印 0不打印
      unit: '1', //单位 1打印 0不打印
      cate: '0', //分类 1打印 0不打印
      decimal: '2', //打印小数 2两位小数 1一位小数
      goods_num_type: '0', //下单数量 1按份数打印 0按基本数量打印
      is_print_out: '1', //缺货商品是否打印 1打印 0不打印
      is_order_amount: '0', //下单金额是否打印 1打印 0不打印
      is_order_sum: '0', // 下单总量是否打印 1打印 0不打印
      is_sorting: '0', // 分拣签名是否打印 1打印 0不打印
      accounts_receivable_name: '', // 收款账户名称
      accounts_receivable: '', // 收款账户
      delivert_time: '', // 送货时间设置
      is_table_header: '1', // 多页打印时候表头是否打印
      is_out_time: '0', // 是否打印出库时间
      is_delivert_time: '1', // 是否打印送货时间 1打印 0不打印
      is_delivert_time_type: '1', // 是否打印送货时间方式 1打印 0不打印
      is_one_print_header: '0', // 单个分页打印是否打印表头 1打印 0不打印
      one_print_line: '', // 单页打印列表行数
      custom_information: [{
        name: ''
      }], // 自定义表格信息
      is_contact: 1, // 是否打印联系方式
      is_supplier: '0', // 是否打印供货商 1打印 0不打印
      is_print_goods_sn: '0', // 是否打印商品自定义编号 1打印 0不打印
      is_print_fixed_line: '0', // 是否打印固定行数 1打印 0不打印
      print_fixed_line_num: '', // 打印固定行数值
      // print_table_space_between:30//表格上下行间距
      is_print_delivery_username: '0', // 是否打印送货员电话 1打印 0不打印
      is_special: '0', // 是否打印具体斤数 1打印 0不打印
      is_money_upper: '0', //1是否打印金额大写 1打印 0不打印
      is_goods_merge: '1', //是否合并商品 1合并 0不合并
      is_signature: '0', //是否打印领导签字
    },
    complate_delivery1: {
      // 1标准模板
      tax_rate: '0', // 标准模板-是否打印税率税费  type=1标准模板时有效
      is_stockout: '1', // 标准模板-缺货商品是否打印 1打印 0不打印
      company_logo: '', // 标准模板-自定义公司logo
      company_name: '', // 标准模板-自定义公司名称
      company_address: '', // 标准模板-自定义公司地址
      company_phone: '', // 标准模板-自定义公司电话
      company_code: '', // 标准模板-自定义公司注册号
      label_code: '', // 标准模板-自定义-发票号文案
      label_date: '', // 标准模板-自定义-日期文案
      table_row: 20, // 标准模板-自定义-每页最多行数
    },
    complate_delivery2: printComplate2, // 2自定义模板 送货单
    complate_delivery3: {
      is_stockout: '1', // 发票单据-缺货商品是否打印 1打印 0不打印
      company_logo: '', // 新加坡 发票单据-自定义公司logo
      company_name: '', // 新加坡 发票单据-自定义公司名称
      company_address: '', // 新加坡 发票单据-自定义公司地址
      company_remark: '', // 新加坡 发票单据-自定义公司信息 TEL GST Email
      bottom_remark: '', // 底部合计备注
      payee_msg: '', // 收款备注
      payee_code: '', // 收款二维码
      date_type: 'dd/MM/yyyy',
    }, // 3新加坡 发票单据模板

    customerList02: [], //客户列表 单位+代收点

    report_print_set: [], //农残报告打印模板
    complate_report_main: {
      uuid: '', // 用于客户编辑时 为客户定制模板 已定制模板的客户不在弹出模板弹窗
      type: '2', // 模板类型 2自定义模板
      report_type: '', // 适用类型
      tab_name: '', //模板名称
      table_name: '《检测》',
    }, // 更改模板参数时 请注意 complate_report0 complate_report1 complate_report2相同参数必须是同一数据类型且值相同
    complate_report2: {
      ...printComplate2,
      top_rules: [],
      thead_rules: [],
      total_rules: [],
      print_date: false,
      additional: [{
        s: 1,
        l: '受检单位签署',
        v: '',
        w: 89,
        sign_l: '经办人',
        sign: '',
        seal: '',
        show: false
      }, {
        s: 1,
        l: '检测单位签署',
        v: '',
        w: 89,
        sign_l: '检测人',
        sign: '',
        seal: '',
        show: false
      }],
      tips: {
        show: false,
        text: '①存根白 ②客户红 ③回单黄'
      },
    }, // 2自定义模板 农残模板

    aftersale_print_set: [], // 售后打印模板
    complate_aftersale_main: {
      uuid: '', // 用于客户编辑时 为客户定制模板 已定制模板的客户不在弹出模板弹窗
      type: '2', // 模板类型 2自定义模板
      tab_name: '', //模板名称
      table_name: '《售后》',
    }, // 更改模板参数时 请注意 complate_aftersale2相同参数必须是同一数据类型且值相同
    complate_aftersale2: {
      ...printComplate2,
      thead_rules: [],
      total_rules: [],
      print_date: false,
      table_style: {
        FS: 4, // px
        LH: 5, // px
        row: 10,
        FF: ''
      },
      tips: {
        show: false,
        text: '①存根白 ②客户红 ③回单黄'
      },
    }, // 2自定义模板 售后打印模板

    system: {
      site_logo: '', // 平台logo
      site_title: '', // 平台名称
      order_print_set: '', // 订单打印模板
      warehouse_receipt_print_set: '', // 入库单打印模板
      delivery_print_set: '', // 配送打印模板
      report_print_set: '', // 农残报告打印模板
      aftersale_print_set: '', // 售后打印模板
      tag_print_set: '', // 自定义分拣端标签模板
      supplier_pricing: '', //供应商定价权力
      star_list: [], // 星级
      plat_lng: '', // 平台经纬度
      plat_lat: '', // 平台经纬度
      plat_address: '', // 平台地址
      server_phone: '', // 平台客服电话
      pricing_scheme: '',
      procure_suggest_cost_setting: '',
      company_name: '', //企业 名称
      company_phone: '', //企业 电话
      company_tax: '', //企业 传真
      company_code: '', //企业 注册号
      language: 'zh-CN', // 主语言

      discount_list: '[]', // 满减
      discount_type: '', // 满减类型

      order_money_floor: '',

      schedule_setting: '', // 班次时间

      is_open_proxy_fee: '',

      is_recharge_present: '',

      is_open_order_tag: '',
      order_tag: '',
    },
    systemTime: 0,
    serviceTime: 0,
    clientWidth: document.body.getBoundingClientRect().width, //可视宽度

    platPrivilege: [], //平台页面权限数据
    isPrivilege: false, //是否为平台编辑权限状态
    userPrivilege: [], //个人权限数据 保存后
    isPrivilegeUser: false, //是否为个人权限编辑
    showWelcome: false
  },
  getters: {
    order_tag_list(state) {
      // 订单标签
      return state.system.order_tag ? JSON.parse(state.system.order_tag) : []
    },
    tag_print_set(state) {
      // 自定义分拣端标签模板
      return state.system.tag_print_set
    },
    warehouse_receipt_print_set: (state) => {
      // 入库单打印模板
      return state.warehouse_receipt_print_set
    },
    delivery_print_set: (state) => {
      // 配送打印模板
      return state.delivery_print_set
    },
    complate_delivery_default: (state) => {
      return {
        ...state.complate_delivery_main,
        ...state.complate_delivery0,
        ...state.complate_delivery1,
        ...state.complate_delivery2,
        ...state.complate_delivery3
      }
    },
    complate_delivery_main: (state) => {
      return state.complate_delivery_main
    },
    order_print_set: (state) => {
      return state.order_print_set
    },
    complate_order_default: (state) => {
      return {
        ...state.complate_order_main,
        ...state.complate_order0,
        ...state.complate_order1,
        ...state.complate_order2,
      }
    },
    complate_order_main: (state) => {
      return state.complate_order_main
    },
    report_print_set: (state) => {
      // 农残报告打印模板
      return state.report_print_set
    },
    complate_report_default: (state) => {
      return {
        ...state.complate_report_main,
        ...state.complate_report2,
      }
    },
    complate_report_main: (state) => {
      return state.complate_report_main
    },

    aftersale_print_set: (state) => {
      // 售后打印模板
      return state.aftersale_print_set
    },
    complate_aftersale_default: (state) => {
      return {
        ...state.complate_aftersale_main,
        ...state.complate_aftersale2,
      }
    },
    complate_aftersale_main: (state) => {
      return state.complate_aftersale_main
    },

    companyName: (state) => {
      return state.companyName
    },
    userInfo(state) {
      return state.user.userInfo
    },
    hasParent(state) {
      return state.user.userInfo.has_parent == 1;
    },
    visitedViews(state) {
      return state.tagsView.visitedViews
    },
    routes(state) {
      return state.tagsView.routes
    },
    starList(state) {
      return state.system.star_list
    },
    starIndexList(state) {
      let list = [];
      state.system.star_list.forEach((item, index) => {
        if (index > 0) {
          list.push(index)
        }
      })
      return list
    },
    isZh(state) {
      return state.system.language === 'zh-CN'
    },
    floorNum(state) {
      return state.system.order_money_floor == 1 ? 1 : 2;
    },
    isFloor(state) {
      return state.system.order_money_floor == 1;
    },
    scheduleSetting(state) {
      return state.system.schedule_setting ? JSON.parse(state.system.schedule_setting) : []
    }
  },
  mutations: {
    //更新state数据
    SET_STATE(state, param) {
      for (let key in param) {
        state[key] = param[key];
      }
    },
    SET_STATE_VAL(state, param) {
      for (let key in param) {
        if (typeof param[key] === 'object') {
          for (let k in param[key]) {
            state[key][k] = param[key][k];
          }
        }
      }
    },
    setRequestTimes(state, params) {
      state.requestTimes[params.name] = params.value;
    },
    setStateConact(state, params) {
      state[params.name] = state[params.name].concat(params.value)
    },
    setStatePush(state, params) {
      state[params.name].push(params.value)
    },
    setState(state, params) {
      state[params.name] = params.value
    }
  },
  actions: {
    setSystem({
      state,
      commit,
      dispatch
    }, params) {
      return new Promise((resolve, reject) => {
        Vue.prototype.request({
          url: '/admin/system/setSys',
          data: params,
          is_public: true,
          complete: (res) => {
            if (res.error_code == 0) {
              commit('SET_STATE_VAL', {
                system: params
              })
              resolve(res)
            } else {
              reject(res)
            }
          }
        })
      })
    },
    getSystem({
      state,
      commit,
      dispatch
    }, time = 60) {
      return new Promise((resolve) => {
        let nowTime = new Date().timestamp();
        if (nowTime - state.systemTime <= time) {
          resolve(state.system)
          return
        }
        // let field = Object.keys(state.system)
        Vue.prototype.request({
          url: '/admin/system/getSys',
          data: {
            // field: field.toString()
            field: 'all'
          },
          is_public: true,
          complete: (res) => {
            if (res.error_code == 0) {
              let data = res.data;
              if (data.site_logo.indexOf('http') === -1) {
                data.site_logo = Vue.prototype.url + data.site_logo;
              }
              // 语言设置 start
              let main_language = data.language;
              if (!main_language || main_language == 'zh-cn') {
                main_language = 'zh-CN';
              }
              data.language = main_language;
              localStorage.setItem('main_language', main_language)
              Vue.prototype.$language = main_language; // 重新设置主语言
              Vue.prototype.setMapInit(data.map_key, data.map_security_code) // 初始化地图
              // 语言设置 end

              // 币种设置 start
              let currencyUnit = data.currency_type;
              if (!data.currency_type) {
                // 货币默认跟着诸语言设置  manager/src/locale/index.js
                currencyUnit = Vue.prototype.$languageCurrency[main_language] || 'CNY';
                data.currency_type = currencyUnit;
              }
              Vue.prototype.initCurrencyData(currencyUnit)
              // 币种设置 end

              //兼容处理
              if (data.is_open_delivery_fee === undefined) {
                data.is_open_delivery_fee = 1;
              }
              if (data.delivery_calc_fee_type === undefined) {
                data.delivery_calc_fee_type = 0;
              }

              commit('SET_STATE', {
                system: data,
                companyName: data.site_title,
                systemTime: new Date().timestamp(),
                serviceTime: res.time,
              })
              dispatch('initPrintSetting', data)
              resolve(data)
            }
          }
        })
      })
    },
    // 初始化 打印配置
    initPrintSetting({
      state,
      getters,
      commit
    }, data) {
      let site_title = state.system.site_title;
      let complateNameTip = state.complateNameTip;
      // 订单打印模板
      let order_print_set = data.order_print_set;
      let orderObj = Vue.prototype.$bus.copyData(getters.complate_order_default)
      if (order_print_set) {
        order_print_set = JSON.parse(order_print_set);
        if (order_print_set.length === undefined) {
          // 老数据 order_print_set是一个单独模板对象
          order_print_set = [order_print_set];
        }
        order_print_set.map((item, index) => {
          for (let key in orderObj) {
            if (key === 'company_name') {
              item[key] = item[key] || site_title
            } else {
              item[key] = item[key] || orderObj[key]
            }
          }
          item.tab_name = item.tab_name || complateNameTip + (index + 1)
        })
      } else {
        order_print_set = [orderObj];
        order_print_set.map((item, index) => {
          item.company_name = item.company_name || site_title
          item.tab_name = item.tab_name || complateNameTip + (index + 1)
        })
      }

      // 送货单打印模板
      let delivery_print_set = data.delivery_print_set;
      let deliveryObj = Vue.prototype.$bus.copyData(getters.complate_delivery_default);
      if (delivery_print_set) {
        delivery_print_set = JSON.parse(delivery_print_set)
        if (delivery_print_set.length === undefined) {
          // 老数据 delivery_print_set是一个单独模板对象
          delivery_print_set = [delivery_print_set];
        }
        delivery_print_set.map((item, index) => {
          for (let key in deliveryObj) {
            if (key === 'company_name') {
              item[key] = item[key] || site_title
            } else {
              item[key] = item[key] || deliveryObj[key]
            }
          }
          item.tab_name = item.tab_name || complateNameTip + (index + 1)
        })
      } else {
        delivery_print_set = [deliveryObj];
        delivery_print_set.map((item, index) => {
          item.company_name = item.company_name || site_title
          item.tab_name = item.tab_name || complateNameTip + (index + 1)
        })
      }

      // 入库单打印模板
      let warehouse_receipt_print_set = data.warehouse_receipt_print_set ? JSON.parse(data
        .warehouse_receipt_print_set) : {};
      for (let i in getters.warehouse_receipt_print_set) {
        let val = warehouse_receipt_print_set[i];
        if (i === 'company_name') {
          val = val || site_title
        } else if (i === 'theads') {
          if (!val || val.length == 0) {
            val = getters.warehouse_receipt_print_set[i];
          } else {
            // 防止新增不显示
            getters.warehouse_receipt_print_set[i].forEach(itm => {
              let isIn = val.find(ite => ite.v == itm.v);
              if (!isIn) {
                val.push(itm);
              }
            })
          }
        } else {
          val = val || getters.warehouse_receipt_print_set[i]
        }
        warehouse_receipt_print_set[i] = val
      }

      // 农残报告打印模板
      let report_print_set = data.report_print_set;
      if (report_print_set) {
        report_print_set = JSON.parse(report_print_set);
      } else {
        report_print_set = [];
      }

      // 售后打印模板
      let aftersale_print_set = data.aftersale_print_set;
      if (aftersale_print_set) {
        aftersale_print_set = JSON.parse(aftersale_print_set);
      } else {
        aftersale_print_set = [];
      }

      commit('SET_STATE', {
        order_print_set,
        delivery_print_set,
        warehouse_receipt_print_set,
        report_print_set,
        aftersale_print_set
      })
    },
    // 平台权限 前端页面显示权限
    getPlatPrivilege({
      state,
      commit,
      dispatch
    }) {
      return new Promise((resolve) => {
        Vue.prototype.request({
          url: '/admin/user/get_frontend_auth',
          data: {},
          is_public: true,
          complete: (res) => {
            if (res.error_code == 0) {
              let data = res.data;
              if (data) {
                data = JSON.parse(data);
              } else {
                data = [];
              }
              commit('SET_STATE', {
                platPrivilege: data
              })
              resolve(data)
            }
          }
        })
      })
    },
    // 个人权限  菜单权限+前端页面显示权限
    getUserPrivilege({
      state,
      commit,
      dispatch
    }) {
      return new Promise((resolve) => {
        Vue.prototype.request({
          url: '/admin/department/getUserAuth',
          is_public: true,
          complete: (res) => {
            if (res.error_code == 0) {
              let data = res.data;
              let backend = data.backend;
              commit('SET_STATE', {
                userPrivilege: data.frontend,
                showWelcome: !!backend.find(item => item.path == '/manager-welcome')
              })
              resolve(data)
            }
          }
        })
      })
    },

  },
  modules: {
    user,
    datas,
    tagsView
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js